var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 1.125H9C6.51819 1.125 4.5 3.14374 4.5 5.625V16.875C4.5 19.3563 6.51819 21.375 9 21.375H27C29.4818 21.375 31.5 19.3563 31.5 16.875V5.625C31.5 3.14374 29.4818 1.125 27 1.125ZM14.625 16.6119V5.88812L23.5613 11.25L14.625 16.6119ZM18 29.25C16.1389 29.25 14.625 27.7361 14.625 25.875C14.625 24.0139 16.1389 22.5 18 22.5C19.8611 22.5 21.375 24.0139 21.375 25.875C21.375 27.7361 19.8611 29.25 18 29.25ZM6.75 29.25C4.88892 29.25 3.375 27.7361 3.375 25.875C3.375 24.0139 4.88892 22.5 6.75 22.5C8.61108 22.5 10.125 24.0139 10.125 25.875C10.125 27.7361 8.61108 29.25 6.75 29.25ZM29.25 29.25C27.3889 29.25 25.875 27.7361 25.875 25.875C25.875 24.0139 27.3889 22.5 29.25 22.5C31.1111 22.5 32.625 24.0139 32.625 25.875C32.625 27.7361 31.1111 29.25 29.25 29.25ZM34.875 32.625V34.875H1.125V32.625H2.4093C2.91248 30.6898 4.6593 29.25 6.75 29.25C8.8407 29.25 10.5875 30.6898 11.0907 32.625H13.6593C14.1625 30.6898 15.9093 29.25 18 29.25C20.0907 29.25 21.8375 30.6898 22.3407 32.625H24.9093C25.4125 30.6898 27.1593 29.25 29.25 29.25C31.3407 29.25 33.0875 30.6898 33.5907 32.625H34.875Z",
    fill: "#FE7320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW2);
export default __webpack_public_path__ + "static/media/w2.00af8fc359e27b829ed0e3e8e26803bf.svg";
export { ForwardRef as ReactComponent };